<template>
    <div class="hts-company-info">
        <hts-card
            title="Thông tin workspace"
            :loading="loading">
            <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-form-input
                    v-model="companyData.workspace.name"
                    label="Tên workspace"
                    name="companyName"
                    prop="name"
                    readonly />
                <hts-form-input
                    v-model="companyData.workspace._sid"
                    label="Workspace Id"
                    name="companyName"
                    prop="name"
                    readonly />
            </div>
        </hts-card>

        <hts-card
            title="Thông tin công ty"
            :loading="loading">
            <hts-form-input
                v-model="companyData.name"
                :label="$t('labels.companyName')"
                name="companyName"
                readonly
                prop="name" />
            <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-form-input
                    v-model="companyData.abbreviationName"
                    readonly
                    :label="$t('labels.abbreviationName')"
                    name="abbreviationName"
                    prop="abbreviationName" />
                <hts-form-input
                    v-model="companyData.taxNumber"
                    readonly
                    :label="$t('labels.taxNumber')"
                    name="taxNumber"
                    prop="taxNumber" />
                <hts-form-input
                    v-model="companyData.email"
                    readonly
                    :label="$t('labels.email')"
                    name="email"
                    prop="email" />
                <hts-form-phone
                    v-model="companyData.phone"
                    :label="$t('labels.phone')"
                    prop="phone"
                    name="phone"
                    readonly
                    @updateCode="(val) => (companyData.phone.code = val)" />

                <hts-form-input
                    v-model="companyData.website"
                    readonly
                    :label="$t('labels.website')"
                    name="website"
                    prop="website" />

                <hts-form-input
                    v-model="companyData.fax"
                    readonly
                    :label="$t('labels.fax')"
                    name="fax"
                    prop="fax" />
                <hts-form-input
                    v-model="companyData.address"
                    readonly
                    :label="$t('labels.address')"
                    name="address"
                    prop="address" />
                <hts-form-input
                    v-model="companyData.locationName"
                    readonly
                    :label="$t('labels.location')"
                    name="location"
                    prop="location" />
            </div>

            <div class="mt-4 flex justify-end">
                <hts-form-button
                    v-if="checkPermission(layoutPermissions.company_edit)"
                    class="mb-4"
                    color="primary"
                    :outline="false"
                    @click="handleOpenUpdate">
                    Cập nhật
                </hts-form-button>
            </div>
        </hts-card>

        <update-company
            ref="updateCompany"
            @update="handleUpdated" />
    </div>
</template>

<script setup lang="ts">
import UpdateCompany from './update.vue'
import layoutPermissions from '~/data/permissions/layout-permissions'

onMounted(async () => {
  await getCompanyInfo()
})

const uploadImage = ref()

const openUploadImage = () => {
  if (uploadImage.value) {
    uploadImage.value.open()
  }
}

const loading = ref(true)
const runtimeConfig = useRuntimeConfig().public
const uploadImg = ref<HTMLElement>()
const updateCompany = ref()
const loaded = ref(false)
const showLocation = ref(false)

const companyData = ref({
  name: '',
  abbreviationName: '',
  taxNumber: '',
  email: '',
  phone: {
    countryCode: '',
    phone: '',
    code: ''
  },
  website: '',
  fax: '',
  address: '',
  locationName: '',
  location: {
    lat: 10.7561542,
    lng: 106.6896784
  },
  workspace: {
    name: '',
    _sid: ''
  }
})

const handleOpenUpdate = () => {
  updateCompany.value && updateCompany.value.open()
}

const handleUpdated = async () => {
  await getCompanyInfo()
}

const getCompanyInfo = async () => {
  loading.value = true
  const company = await $api($url.company.getHoldingCompany)
  const data: any = $lodash.get(company, 'data.value')
  const error: any = $lodash.get(company, 'error')

  if (data.success) {
    if (!data.data.phone) {
      data.data.phone = {
        countryCode: '',
        phone: '',
        code: ''
      }
    }
    companyData.value = data.data
  }
  loading.value = false
}
</script>
